import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { GATEWAY_JOIN_PROFILE_LIST } from 'src/constants/queryKeys';

export const networkGetGatewayJoinProfileList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GatewayJoinGatewayProfile/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGatewayJoinProfileList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [GATEWAY_JOIN_PROFILE_LIST, payload, pageIndex],
    queryFn: () => networkGetGatewayJoinProfileList(payload, pageIndex, pageSize),
  });
}

export const networkGetGatewayJoinProfileInfo = async (id) => {
  const res = await axiosInstance.post(`GatewayJoinGatewayProfile/Info/${id}`);
  return res;
};

export function useFetchGatewayJoinProfileInfo(id) {
  return useQuery({
    queryKey: ['gateway-join-gateway-profile-info', id],
    queryFn: () => networkGetGatewayJoinProfileInfo(id),
  });
}

export const networkCreateGatewayJoinProfile = async (data) => {
  const res = await axiosInstance.post('GatewayJoinGatewayProfile/Insert', data);
  return res;
};

export const networkUpdateGatewayJoinProfile = async (id, data) => {
  const res = await axiosInstance.post(`GatewayJoinGatewayProfile/Update/${id}`, data);
  return res;
};

export const networkRemoveGatewayJoinProfile = async (id) => {
  const res = await axiosInstance.post(`GatewayJoinGatewayProfile/Remove/${id}`);
  return res;
};

export const networkGetGatewayJoinProfileActiveTypeList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GatewayJoinGatewayProfileActiveType/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchGatewayJoinProfileActiveTypeList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['gateway-join-gateway-profile-active-type-list', pageIndex],
    queryFn: () => networkGetGatewayJoinProfileActiveTypeList(pageIndex, pageSize),
  });
}
